import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  gap: (p) => p.spacing(1),
  mt: (p) => p.spacing(1.5),
  minHeight: (p) => p.spacing(7),
};

export const labelRow: SxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: (p) => p.spacing(0.25),
};

export const tooltipAnchor: SxStyle = {
  display: 'flex',
};

export const labelSlot: SxStyle = {
  minHeight: (p) => p.spacing(2),
};
